module.exports = __webpack_public_path__ + "img/creme_brulee_eat.b689fd35.jpg";